import React, { useState, useEffect } from 'react'
import Layout from '../components/Layout'
import Hero from '../components/Hero'
import { Link } from 'gatsby'
import styled from 'styled-components'
import Image from 'gatsby-image'
import Banner from '../components/Banner'
import { graphql } from 'gatsby'
import { MDXRenderer } from 'gatsby-plugin-mdx'
import FAQ from '../pages/faq'
import { FcCheckmark } from 'react-icons/fc'
import { GiPlasticDuck, GiCancel } from 'react-icons/gi'
import { AuthContext } from '../context/AuthContext'
import { useContext } from 'react'
import { Helmet } from 'react-helmet'

const ProjectTemplate = ({ data }) => {
  const GitHubUser = useContext(AuthContext)
  const {
    mdx: {
      frontmatter: { title, category, image, date, brief, download },
      body,
    },
  } = data
  useEffect(() => {
    // research: https://usehooks.com/useScript/
    // https://www.gatsbyjs.org/packages/gatsby-plugin-load-script/?=gatsby-plugin-load
    // https://github.com/gatsbyjs/gatsby/issues/11013
    //   const script = document.createElement('script')
    //   script.async = true
    //   script.src = 'https://cdn.paddle.com/paddle/paddle.js'
    if (typeof window !== `undefined`) {
      window.Paddle.Setup({ vendor: 116699 })
    }
  }, [])

  return (
    <section>
      <Helmet>
        {/* <script src="https://cdn.paddle.com/paddle/paddle.js"></script> */}

        {/* <script type="text/javascript">
          {typeof window !== `undefined` &&
            window.Paddle.Setup({ vendor: 116699 })}
        </script> */}
        <script
          type="text/javascript"
          src="https://transactions.sendowl.com/assets/sendowl.js"
        ></script>
      </Helmet>
      <Hero></Hero>

      <Wrapper>
        {/* <button className="mdx-button">
          <a
            href="#!"
            className="paddle_button"
            data-product="597668"
            data-theme="none"
          >
            Buy Now!
          </a>
        </button> */}
        {/* project info */}
        <div className="flex">
          <div className="grid-area-one">
            <article>
              <Banner />
            </article>
            <iframe
              className="iframe"
              src={brief}
              allowFullScreen
              disabled
            ></iframe>
            {/* <a href="#"></a> */}
            <div className="iframe-cover"></div>
          </div>
          <div className="post-info grid-area-two">
            {/* <span className="category">{category}</span> */}
            <h2 className="title">{title}</h2>
            <div className="underline"></div>
            <br />
            {/* {GitHubUser.isAuthenticated && ( */}
            <a href={download}>
              <button className="btn">DOWNLOAD STARTER (FREE)</button>
            </a>
            {/* )} */}
            {/* {!GitHubUser.isAuthenticated && (
              <a>
                <div className="btn">Login to Download Starter (FREE)</div>
              </a>
            )} */}
            <ul className="download-includes">
              <li className="download-includes-item">
                <FcCheckmark className="check-mark" />
                README file to help you get started
              </li>
              <li className="download-includes-item">
                <FcCheckmark className="check-mark" />
                Style guide for fonts, colors, etc
              </li>
              <li className="download-includes-item">
                <FcCheckmark className="check-mark" />
                HTML file with pre-written content
              </li>
              <a href="#sketch">
                <li className="download-includes-item">
                  <GiCancel className="not-included" /> Figma design file -
                  Learn More
                </li>
              </a>
            </ul>
          </div>
        </div>
        {/* <button>
          <a
            href="https://transactions.sendowl.com/products/78341454/BF2B50F2/purchase"
            rel="nofollow"
          >
            Buy Now!
          </a>
         
        </button> */}
        {/* <button>
          <a href="https://sowl.co/VKMSq" target="_blank">
            Hope this works everytime
          </a>
        </button>
        <button>
          <a href="https://google.com" target="_blank">
            Google Link
          </a>
        </button>
        <a href="https://google.com" target="_blank">
          Google Link
        </a> */}
        <MDXRenderer>{body}</MDXRenderer>
        {/* <Link to="/projects" className="btn center-btn">
          all projects
        </Link> */}
      </Wrapper>

      {/* banner component */}
      <FAQ />
    </section>
  )
}

export const query = graphql`
  query GetSingleProject($slug: String) {
    mdx(frontmatter: { slug: { eq: $slug } }) {
      frontmatter {
        title
        brief
        download
        category
        date(formatString: "MMM Do, YYYY")
        image {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
      body
    }
  }
`

const Wrapper = styled.section`
  .grid-area-one {
    position: relative;
  }
  .flex {
    display: flex;
    flex-direction: column;
  }
  .iframe {
    width: 375px;
    height: 250px;
  }
  .iframe-cover {
    height: 50px;
    width: 100%;
    position: absolute;
    z-index: 10;
    bottom: 0;
  }
  iframe a {
    display: none;
    height: none;
  }

  a.embed_documentation_footer--documentationFooter--2gpG4 {
    display: none;
    min-height: 0px;
  }

  iframe footer {
    display: none;
    height: none;
  }

  .section-header {
    display: none;
  }
  .mdx-section {
    margin-bottom: 15px;
    /* margin-top: 12px; */
  }
  .mdx-section ul {
  }
  .mdx-button {
    display: grid;
    place-items: center;
    margin: 10px auto;
    background: red;
    color: yellow;
    opacity: 1;
    width: 150px;
    border-radius: 12px;
    height: 35px;
    /* padding: 15px 12px; */
    border: none;
  }

  .mdx-button a {
    color: white;
    font-size: 16px;
    /* display: none; */
  }

  .check-mark {
    /* color: #fdf; */
    size: 24px;
    margin-right: 12px;
    font-size: 30px;
    /* display: inline; */
  }
  .not-included {
    color: red;
    margin-right: 12px;
    font-size: 36px;
  }
  .checkmark {
    color: #48a047;
  }

  .download-includes-item {
    /* height: 40px; */
    display: flex;
    flex-direction: row;
    /* justify-content: center; */
    align-items: center;
    /* margin-bottom: 5px; */
  }
  width: 85vw;
  max-width: 1100px;
  margin: 0 auto;
  margin-bottom: 4rem;
  .image-desktop {
    /* width: 100%; */
  }

  .btn-image-size {
    /* width: 50%; */
    margin-top: 15px;
    padding: 5px 10px;
    margin-right: 10px;
  }
  .category {
    text-align: left;
  }
  .post-info {
    margin: 2rem 0 4rem 0;
    text-align: left;
    span {
      background: var(--clr-primary-5);
      color: var(--clr-white);
      border-radius: var(--radius);
      padding: 0.25rem 0.5rem;
      text-transform: uppercase;
      letter-spacing: var(--spacing);
    }
    h2 {
      /* margin: 1.25rem 0; */
      font-weight: 400;
    }
    p {
      color: var(--clr-grey-5);
    }
    .underline {
      width: 5rem;
      height: 1px;
      background: var(--clr-grey-9);
      margin: 0 auto;
      margin-bottom: 1rem;
    }
    .download-includes {
      /* display: none; */
      margin-top: 25px;
      text-align: left;
    }
  }
  @media (min-width: 768px) {
    /* .image-desktop { */
    /* width: 90%; */
    /* padding: 50px; */
    /* display: none; */
    /* } */
    .image-mobile {
    }
    .post-info {
      margin-right: 0;
    }
  }
  @media (min-width: 992px) {
    & {
      width: 92vw;
    }
    .flex {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
    }
    .iframe {
      width: 550px;
      height: 350px;
    }
    /* .iframe-cover {
      height: 40px;
      width: 100%;
    } */
    .mdx-section {
      margin-bottom: 15px;
      margin-top: 25px;
    }
    .iframe-cover {
      height: 100px;
      width: 100%;
      position: absolute;
      z-index: 10;
      bottom: 0;
      /* border: 2px solid green; */
    }
    /* grid-template-columns: 2fr 2fr; */
    grid-template-areas:
      'a b'
      'c c';
    grid-gap: 50px;
    /* .image { */
    /* padding: 50px; */
    /* background: #f8f8f8; */
    /* border-radius: 5px; */
    /* } */
    .mdx-styling {
      /* display: none; */
      max-width: 1200x;
    }
    .grid-area-one {
      grid-area: a;
    }
    .grid-area-one {
      grid-area: b;
    }
    .grid-area-two {
      margin-top: -5px;
      transform: scale(1);
      transition: transform 0.4s;
    }
    .grid-area-two:hover {
      transform: translate3D(0, -1px, 0) scale(1.13);
      transition: all 0.4s ease; /* zoom in */
    }
    .grid-area-three {
      /* display: none; */
      grid-area: c;
    }
    .download-includes {
      text-align: center;
      margin-bottom: 5px;
    }
    .check-mark {
      size: 36px;
    }
    .post-info {
      /* text-align: center; */
    }
    .image {
      width: 700px;
      /* height: 100%; */
    }
  }
  @media (min-width: 1200px) {
    .post-info {
      margin-right: 75px;
    }
  }
  /* @media (min-width: 1170px) {
    & {
      display: grid;
      grid-template-columns: 1fr 200px;
      column-gap: 4rem;
    }
  } */
`

export default ProjectTemplate
